/**
 * Service para Dashboard Administrativo
 * Gerencia comunicação com API para funções administrativas
 */

import api from './api';

/**
 * Obter estatísticas gerais do sistema
 */
export const getEstatisticasGerais = async () => {
  try {
    const response = await api.get('/admin/estatisticas');
    return response; // Interceptor já retorna response.data
  } catch (error) {
    console.error('Erro ao buscar estatísticas gerais:', error);
    throw error;
  }
};

/**
 * Listar todos os usuários com paginação
 */
export const listarUsuarios = async (params = {}) => {
  try {
    const { page = 1, limit = 10, search = '', ordenar = 'createdAt', ordem = 'DESC' } = params;
    const response = await api.get('/admin/usuarios', {
      params: { page, limit, search, ordenar, ordem }
    });
    return response; // Interceptor já retorna response.data
  } catch (error) {
    console.error('Erro ao listar usuários:', error);
    throw error;
  }
};

/**
 * Obter detalhes de um usuário específico
 */
export const getUsuarioDetalhes = async (userId) => {
  try {
    const response = await api.get(`/admin/usuarios/${userId}`);
    return response; // Interceptor já retorna response.data
  } catch (error) {
    console.error('Erro ao buscar detalhes do usuário:', error);
    throw error;
  }
};

/**
 * Alternar status ativo/inativo do usuário
 */
export const toggleStatusUsuario = async (userId) => {
  try {
    const response = await api.patch(`/admin/usuarios/${userId}/toggle-status`);
    return response; // Interceptor já retorna response.data
  } catch (error) {
    console.error('Erro ao alternar status do usuário:', error);
    throw error;
  }
};

/**
 * Obter atividades recentes do sistema
 */
export const getAtividadesRecentes = async (limit = 20) => {
  try {
    const response = await api.get('/admin/atividades', {
      params: { limit }
    });
    return response; // Interceptor já retorna response.data
  } catch (error) {
    console.error('Erro ao buscar atividades recentes:', error);
    throw error;
  }
};

/**
 * Obter dados para gráfico de crescimento de usuários
 */
export const getGraficoCrescimento = async (periodo = '12') => {
  try {
    const response = await api.get('/admin/grafico-crescimento', {
      params: { periodo }
    });
    return response; // Interceptor já retorna response.data
  } catch (error) {
    console.error('Erro ao buscar gráfico de crescimento:', error);
    throw error;
  }
};

/**
 * Obter distribuição de tipos de usuário
 */
export const getDistribuicaoTipos = async () => {
  try {
    const response = await api.get('/admin/distribuicao-tipos');
    return response; // Interceptor já retorna response.data
  } catch (error) {
    console.error('Erro ao buscar distribuição de tipos:', error);
    throw error;
  }
};

const adminService = {
  getEstatisticasGerais,
  listarUsuarios,
  getUsuarioDetalhes,
  toggleStatusUsuario,
  getAtividadesRecentes,
  getGraficoCrescimento,
  getDistribuicaoTipos
};

export default adminService;
